


















































































































































































































































import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Emit, Mixins, Prop } from "vue-property-decorator";
import { Lead, LeadService } from "@/services/lead.service";
import Tooltip from "@/shared/components/tooltip.vue";
import dayjs from "dayjs";
import EditarLead from "../modals/EditarLead.vue";
import MudarStatus from "../modals/MudarStatus.vue";
import MudarEtapa from "../modals/MudarEtapa.vue";
import ReagendarAtendimento from "../modals/ReagendarAtendimento.vue";
import { telefone } from "@/shared/filters";

@Component({
  components: {
    Tooltip,
    EditarLead,
    MudarStatus,
    ReagendarAtendimento,
    MudarEtapa,
  },
  filters: { telefone },
})
export default class DadosLead extends Mixins(GlobalMixin) {
  @Prop() readonly idLead!: number;

  lead: Lead | null = null;
  loading = false;
  etapaLead = "";
  statusLead = "";
  tipoLead = "";
  dataCadastro = "";
  dataAgendamento = "";
  nomeResponsavel = "";

  mounted() {
    this.fetchDadosLead(this.idLead);
  }

  @Emit("onChange")
  onChange() {
    return this.lead;
  }

  async editarLead() {
    const modal = this.$refs.editarLead as EditarLead;
    if (this.lead) {
      await modal.editarLead(this.lead);
    }
    this.fetchDadosLead(this.idLead, false);
    this.onChange();
  }

  async mudarStatus() {
    const modal = this.$refs.mudarStatus as MudarStatus;
    if (this.idLead) {
      await modal.mudarStatus(this.idLead);
    }
    this.fetchDadosLead(this.idLead);
    this.onChange();
  }

  async mudarEtapa() {
    const modal = this.$refs.mudarEtapa as MudarEtapa;
    if (this.idLead) {
      await modal.mudarEtapa(this.idLead);
    }
    this.fetchDadosLead(this.idLead);
    this.onChange();
  }

  async reagendarAtendimento() {
    const modal = this.$refs.reagendarAtendimento as ReagendarAtendimento;
    if (this.idLead) {
      await modal.reagendarAtendimento(this.idLead);
    }
    this.fetchDadosLead(this.idLead);
    this.onChange();
  }

  async fetchDadosLead(idLead: number, marcarResponsavel = true) {
    this.loading = true;
    try {
      this.lead = await LeadService.obterLead(idLead, marcarResponsavel);
      this.nomeResponsavel = "";
      if (this.lead.idUsuario) {
        this.nomeResponsavel = await LeadService.obterResponsavelLead(
          this.lead.idUsuario
        );
      }

      switch (this.lead.idTipoLead) {
        case 1:
          this.tipoLead = "Indicação";
          break;
        case 2:
          this.tipoLead = "Campanha";
          break;
        case 3:
          this.tipoLead = "Prospecção";
          break;
        default:
          this.tipoLead = "";
      }

      switch (this.lead.idEtapaLead) {
        case 0:
          this.etapaLead = "Oportunidade";
          break;
        case 1:
          this.etapaLead = "Primeiro Contato";
          break;
        case 2:
          this.etapaLead = "Segundo Contato";
          break;
        default:
          this.etapaLead = "";
      }

      switch (this.lead.idStatusLead) {
        case 1:
          this.statusLead = "Em Processo";
          break;
        case 2:
          this.statusLead = "Qualificado";
          break;
        case 3:
          this.statusLead = "Ganho";
          break;
        case 4:
          this.statusLead = "Perda";
          break;
        case 8:
          this.statusLead = "Já Cadastrado";
          break;
        case 9:
          this.statusLead = "Erro";
          break;
        default:
          this.statusLead = "";
      }

      this.dataCadastro = dayjs(this.lead.dataCadastro).format(
        "DD/MM/YYYY - HH:mm"
      );
      if (this.lead.dataAgendamento) {
        this.dataAgendamento = dayjs(this.lead.dataAgendamento).format(
          "DD/MM/YYYY - HH:mm"
        );
      }
    } finally {
      this.loading = false;
    }
  }
}
